import { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { NotificationBell } from '../notifications/NotificationBell';

const navLink = ({ isActive }: { isActive: boolean }) =>
  `text-sm font-bold transition ${isActive ? 'text-[#FF9933]' : 'text-white/85 hover:text-[#FF9933]'}`;

export const PublicHeader = () => {
  const { isAuthenticated, role, logout } = useAuth();
  const [open, setOpen] = useState(false);

  const dashboardPath =
    role === 'PILOT' ? '/pilot/dashboard'
      : role === 'CLIENT' ? '/client/dashboard'
      : role === 'ADMIN' || role === 'SUPER_ADMIN' ? '/admin/dashboard'
      : role === 'SUPPORT_AGENT' ? '/support/dashboard'
      : '/';

  return (
    <header className="sticky top-0 z-40 bg-[#000080]/95 text-white backdrop-blur supports-[backdrop-filter]:bg-[#000080]/85 border-b border-white/10">
      <div className="mx-auto flex max-w-7xl items-center justify-between gap-4 px-5 py-4">
        <Link to="/" className="flex items-center gap-2">
          <span aria-hidden className="flex h-6 w-6 overflow-hidden rounded">
            <span className="h-full w-1/3 bg-[#FF9933]" />
            <span className="h-full w-1/3 bg-white" />
            <span className="h-full w-1/3 bg-[#138808]" />
          </span>
          <span className="text-xl font-black tracking-tight">AeroBott</span>
          <span className="hidden md:inline-block rounded-full border border-white/20 px-2 py-0.5 text-[10px] font-black World-gold-text">India Drone Mission</span>
        </Link>
        <nav className="hidden lg:flex items-center gap-6">
          <NavLink to="/how-it-works" className={navLink}>How it Works</NavLink>
          <NavLink to="/post-job" className={navLink}>Post a Job</NavLink>
          <NavLink to="/done-for-you" className={navLink}>Done For You</NavLink>
          <NavLink to="/pilots" className={navLink}>Browse Pilots</NavLink>
          <NavLink to="/pilots/map" className={navLink}>Map</NavLink>
          <NavLink to="/portfolio-reels" className={navLink}>Portfolio Reels</NavLink>
          <NavLink to="/services" className={navLink}>Services</NavLink>
        </nav>
        <div className="hidden lg:flex items-center gap-3">
          {isAuthenticated ? (
            <>
              <NotificationBell tone="on-dark" />
              <Link to={dashboardPath} className="text-sm font-bold text-white/85 hover:text-[#FF9933]">Dashboard</Link>
              <button onClick={() => void logout()} className="rounded-xl border border-white/30 px-3 py-1.5 text-sm font-black text-white hover:bg-white/10">Log out</button>
            </>
          ) : (
            <>
              <Link to="/login" className="text-sm font-bold text-white/85 hover:text-[#FF9933]">Login</Link>
              <Link to="/register" className="rounded-xl bg-[#FF9933] px-4 py-2 text-sm font-black text-[#000080]">Sign Up</Link>
            </>
          )}
        </div>
        <button onClick={() => setOpen((v) => !v)} className="lg:hidden rounded-lg border border-white/20 p-2 text-white" aria-label="Toggle menu">
          <span className="block h-0.5 w-5 bg-white" /><span className="my-1 block h-0.5 w-5 bg-white" /><span className="block h-0.5 w-5 bg-white" />
        </button>
      </div>
      {open ? (
        <nav className="lg:hidden border-t border-white/10 bg-[#000080] px-5 py-4 grid gap-3 text-sm font-bold">
          <Link onClick={() => setOpen(false)} to="/how-it-works">How it Works</Link>
          <Link onClick={() => setOpen(false)} to="/post-job">Post a Job</Link>
          <Link onClick={() => setOpen(false)} to="/done-for-you">Done For You</Link>
          <Link onClick={() => setOpen(false)} to="/pilots">Browse Pilots</Link>
          <Link onClick={() => setOpen(false)} to="/portfolio-reels">Portfolio Reels</Link>
          <Link onClick={() => setOpen(false)} to="/services">Services</Link>
          {isAuthenticated ? (
            <>
              <Link onClick={() => setOpen(false)} to={dashboardPath}>Dashboard</Link>
              <button onClick={() => { setOpen(false); void logout(); }} className="text-left">Log out</button>
            </>
          ) : (
            <>
              <Link onClick={() => setOpen(false)} to="/login">Login</Link>
              <Link onClick={() => setOpen(false)} to="/register" className="rounded-lg bg-[#FF9933] px-3 py-2 text-[#000080] inline-block w-fit">Sign Up</Link>
            </>
          )}
        </nav>
      ) : null}
    </header>
  );
};
